export default __webpack_public_path__ + "static/media/nantez.b5d3c91c.png";